import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function updateProfileDataReducer(
  state = initialState.updateProfileData,
  action
) {
  if (action.type === types.LOADED_UPDATE_PROFILE_SUCCESS) {
    return action.updateProfileData;
  }
  return state;
}
